import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';

const purposes = document.querySelector('#purposes');
const confirmPurpose = document.querySelector('.confirm-purpose');

if (purposes) {
    new Choices(purposes, {
        searchEnabled: false,
        itemSelectText: '',
        shouldSort: false,
    });

    purposes.addEventListener('change', function () {
        const value = this.value;

        if (confirmPurpose && value) {
            confirmPurpose.setAttribute('href', `mailto:${value}`);
        }
    });
}
